import { css } from 'styled-components';
import { Color, Spacing } from '@atomic/obj.constants';
export const clickableFocusCss = css `
  outline-offset: ${Spacing.XSmall};
  outline: 2px solid ${Color.Neutral};
`;
